export default function hiddenSections(sections: string[], when: boolean): void {
  sections.forEach((section) => {
    const element = document.getElementById(`form-section-${section}`);
    if (!element) return;
    if (when) {
      element.classList.add('is-hidden');
    } else {
      element.classList.remove('is-hidden');
    }
  });
}
